// extracted by mini-css-extract-plugin
export default {"column-empty-state":"_7Gux5___BuildingsTable-module__column-empty-state"};